export const TIMER_SEC = 3000;
export const scriptURL =
  'https://script.google.com/macros/s/AKfycbxoWFBG69ESjM56PdAYr8p19GniO9y-WhTjKNbMTFVfz_yAdxsnFGAJhFsdx4MYBSfm/exec';
export const TIMEOUT_SEC = 5000;
export const REGADDRESS = '37 Folly View Road, Faringdon, England, SN7 7DQ';
